/**
 * New Arrivals Section JavaScript
 * Scroll animations + Magnetic cursor effect
 */

class NewArrivalsSection {
  constructor(container) {
    this.container = container;
    this.cards = container.querySelectorAll('.product-card');
    
    this.initScrollAnimations();
    
    if (window.innerWidth >= 1024) {
      this.initMagneticCursor();
    }
  }
  
  initScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, index * 100);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    this.cards.forEach(card => {
      observer.observe(card);
    });
  }
  
  initMagneticCursor() {
    this.cards.forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const deltaX = (x - centerX) / centerX;
        const deltaY = (y - centerY) / centerY;
        
        const tiltX = deltaY * 3;
        const tiltY = deltaX * -3;
        
        card.style.transform = `perspective(1000px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) translateY(-8px)`;
      });
      
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
      });
    });
  }
}

if (typeof window.Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('section-new-arrivals')) {
      new NewArrivalsSection(event.target);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('[data-section-type="new-arrivals"]');
  sections.forEach(section => {
    new NewArrivalsSection(section);
  });
});